import * as Objdict from "objdict"

import App from "@frog/source/models/App.js"
import Director from "@frog/source/juice/Director.js"

import timer from "@frog/source/juice/utility/timer.js"
import pixel from "@frog/source/views/utility/pixel.js"

import Zone from "@frog/source/models/Zone.js"
import Elements from "@frog/source/data/elements.js"
import Colors from "@frog/source/data/colors.js"
import Random from "@frog/source/utility/Random.js"
import Geometry from "@frog/source/utility/Geometry.js"
import Loop from "@frog/source/utility/Loop.js"
import {getTime} from "@frog/source/juice/utility/Time.js"

import {units} from "@frog/source/data/units.js"

import HealthBar from "@frog/source/views/HealthBar.view.js"

const PALETTES = {
    "red": require("@frog/source/assets/images/pirate-tactics/units/palette-red.png").default,
    "green": require("@frog/source/assets/images/pirate-tactics/units/palette-green.png").default,
    "blue": require("@frog/source/assets/images/pirate-tactics/units/palette-blue.png").default,
    "purple": require("@frog/source/assets/images/pirate-tactics/units/palette-purple.png").default,
    "gray": require("@frog/source/assets/images/pirate-tactics/units/palette-gray.png").default,
}

export default function Units(stage) {
    return Object.values(stage.units).map((unit, index) => {
        if(unit.isDead == true) return
        if(unit.hasBeenRemoved == true) return
        if(unit.isNotRendered) return

        // TODO: Removed, because the animations now make them temporarily out of bounds, and it looks weird to blip in and out.
        // if(Zone.isOutOfBounds(stage.encounters[stage.currentEncounter || 1].zone, unit.position)) {
        //     return
        // }

        return [
            Shadow(stage, unit),
            {
                "key": "Unit/" + unit.key,
                "position": UnitPixelPosition(stage, unit),
                "_": [
                    {
                        "key": "Sprite",
                        "image": UnitImage(stage, unit, index),
                        "isFlipped": UnitFlipped(stage, unit),
                        "outline": UnitOutline(stage, unit),
                        "grayscale": UnitGrayscale(stage, unit),
                        "opacity": unit.opacity != undefined ? unit.opacity : undefined,
                        "rotation": UnitRotation(stage, unit),

                        "anchor": {"x": "50%", "y": "100%"},
                        // "palette": UnitPalette(stage, unit),
                        // "anchor": {"x": "50%", "y": "100%"},

                        "tint": UnitTint(stage, unit),
                    },
                    // ElementalMark(stage, unit),
                    isShowingHealthBar(unit) == true && {
                        "position": {
                            "x": ((3 * unit.maxhealth) / -2) + (3 / 2) - 2,
                            "y": -10, // HEIGHT * -1 - 1,
                            "stack": 5
                        },
                        // "color": "yellow",
                        // "width": 8,
                        // "height": 3,
                        "_": [
                            // unit.armor > 0 && {
                            //     "color": Colors.blue,
                            //     "width": unit.maxhealth * 3 + 3,
                            //     "height": 7,
                            //     "position": {"x": -2, "y": -7}
                            // },
                            HealthBar(stage, unit),
                        ]
                    },
                    unit.effects?.burning != undefined && {
                        "image": require("@frog/source/assets/images/ninja-tactics/first-pass/burning.png").default,
                        "position": {
                            "x": Random.range(-1, 1),
                            "y": Random.range(-1, 1),
                        },
                        "anchor": {
                            "x": "50%",
                            "y": "100%",
                        }
                    }
                ]
            }
        ].concat(TrapSprites(stage, unit))
    })
}

function UnitRotation() {
    return 45
}

function isShowingHealthBar(unit) {
    return unit.disableHealth != true
        && unit.type != "zone"
        // && unit.type != "explosive"
        // && unit.affiliation == "good"
}

function Shadow(stage, unit) {
    const position = UnitPosition(stage, unit)
    position.z = unit.position.z
    if(unit.opacity < 1) {
        return
    }
    if(App.game.encounter.phase == "prepare"
    && App.game.encounter.selection.selectedUnitKey == unit.key) {
        return
    }
    if(unit.type == "zone") {
        return
    }
    if(unit.type == "plant") {
        return
    }
    return {
        "key": "Unit/" + unit.key + "/Shadow",
        "position": pixel("unit", position),
        "anchor": {"x": "50%", "y": "100%"},
        // "blendmode": "cool",
        "image": unit.affiliation == "bad" ? require("@frog/source/assets/images/apocalypse-tactics/units/shadow_lg.png").default : require("@frog/source/assets/images/apocalypse-tactics/units/shadow.png").default,
    }
}

import {getFrameFromAnimation, getImageFromAnimation} from "@frog/source/juice/utility/getFrameFromAnimation.js"

const DIRECTIONS = {
    SOUTH: {"y": +1, "x": 0},
    NORTH: {"y": -1, "x": 0},
    WEST: {"x": -1, "y": 0},
    EAST: {"x": +1, "y": 0},
}

function UnitTint(stage, unit) {
    // if(stage.light != undefined
    // && stage.light[unit.position.x + "x" + unit.position.y] == undefined) {
    //     return {
    //         "color": 0x222222,
    //         "intensity": 0.5,
    //     }
    // }
}

function UnitFlipped(stage, unit) {
    if(unit.direction != undefined) {
        return Geometry.equals(unit.direction, DIRECTIONS.EAST)
            || Geometry.equals(unit.direction, DIRECTIONS.NORTH)
    }
    // if(unit.affiliation != "good") {
    //     return true
    // }
}

function UnitImage(stage, unit, index = 0) {
    const offsetTime = (unit.affiliation == "bad" ? 500 : 0) // + (index * 10)
    const totalDuration = getTime().ms
    const hoveredDuration = totalDuration - App.game.encounter.selection.hoveredTime

    if(unit.image != undefined) {
        return unit.image
    }

    if(unit.images == undefined
    || unit.images.sprites == undefined) {
        return
    }

    if(unit.type == "plant") {
        if(unit.state == "withered"
        && unit.images.sprites[unit.level + "w"] != undefined) {
            return unit.images.sprites[unit.level + "w"]
        }
        if(unit.images.sprites[unit.level] != undefined) {
            return unit.images.sprites[unit.level]
        }
    }

    // if(Director.isPerforming
    // && unit.images.sprites["idle"] != undefined) {
    //     return unit.images.sprites["idle"].frames[0].image
    // }

    // if(unit.state == "submerged") {
    //     return require("@frog/source/assets/images/ninja-tactics/iso-pass/x.png").default
    // }
    // if(unit.state == "submerged") {
    //     if(unit.images.sprites["submerged/idle"] != undefined) {
    //         return getImageFromAnimation(unit.images.sprites["submerged/idle"], totalDuration + offsetTime)
    //     }
    // }

    // let direction = "front"
    // const WEST = {"x": -1, "y": 0}
    // const NORTH = {"y": -1, "x": 0}
    // if(Geometry.equals(unit.direction, WEST)
    // || Geometry.equals(unit.direction, NORTH)) {
    //     direction = "back"
    // }

    // if(unit.images.sprites["idle/" + direction] != undefined) {
    //     return getImageFromAnimation(unit.images.sprites["idle/" + direction], totalDuration + offsetTime)
    // }
    //
    // if(unit.images.sprites["static/" + direction] != undefined) {
    //     return unit.images.sprites["static/" + direction]
    // }
    // if(unit.images.sprites["idle/front"] != undefined) {
    //     return getImageFromAnimation(unit.images.sprites["idle/front"], totalDuration + offsetTime)
    // }

    // if(unit.images.sprites["static/front"] != undefined) {
    //     return unit.images.sprites["static/front"]
    // }


    if(window.tutorial === 0 && unit.type == "gaurdner") {
        return getImageFromAnimation(unit.images.sprites["hover"], totalDuration + offsetTime)
    }

    if(App.game.encounter.phase == "play") {
        if(unit.mode == "attack") {
            if(unit.images.sprites["attack"] != undefined) {
                return unit.images.sprites["attack"]
            }
        }
        if(unit.mode == "nothing") {
            if(unit.images.sprites["static"] != undefined) {
                return unit.images.sprites["static"]
            }
        }
        if(unit.energy["invoke skill"] > 0
        && unit.affiliation == "good") {
            if(unit.images.sprites["run"] != undefined
            && App.game.encounter.selection.selectedUnitKey == unit.key) {
                const frame = getFrameFromAnimation(unit.images.sprites["run"], totalDuration + offsetTime)
                return frame.image
            }
            if(unit.images.sprites["hover"] != undefined
            && App.game.encounter.selection.hoveredUnitKey == unit.key) {
                const frame = getFrameFromAnimation(unit.images.sprites["hover"], hoveredDuration + offsetTime)
                return frame.image
            }
        }

        if(unit.images.sprites["idle"] != undefined) {
            // if(unit.affiliation == "bad"
            // && unit.state == "idle") {
            //     return unit.images.sprites["idle"].frames[0].image
            // }
            return getImageFromAnimation(unit.images.sprites["idle"], totalDuration + offsetTime)
        }
    }

    if(unit.images.sprites["static"] != undefined) {
        return unit.images.sprites["static"]
    }
}

function UnitPalette(stage, unit) {
    if(unit.grayscale != undefined) {
        return PALETTES["gray"]
    }
    // if(unit.affiliation == "bad"
    // && unit.state == "idle") {
    //     return PALETTES["gray"]
    // }
    if(unit.energy["move"] == false
    && unit.energy["invoke skill"] == false) {
        return PALETTES["gray"]
    }
    if(unit.affiliation == "good") return PALETTES["blue"]
    if(unit.affiliation == "bad") return PALETTES["red"]
    if(unit.affiliation == "neutral") return PALETTES["purple"]
    if(unit.affiliation == "undead") return PALETTES["green"]

    return PALETTES["red"]
}

function UnitOutline(stage, unit) {
    if(window.tutorial === 0 && unit.type == "gaurdner"
    || window.tutorial === 1 && unit.type == "bug"
    || window.tutorial2 === 0 && unit.type == "plant") {
        return {"thickness": 2, "color": "#fcea88"}
    }
    if(Director.isPerforming == true) return
    if(unit.key == undefined) return
    // if(App.game.encounter.selection.selectedUnitKey == unit.key) {
    //     return {"thickness": 2, "color": "#fbfcdf"}
    // }
    if(App.game.encounter.selection.hoveredUnitKey == unit.key
    && App.game.encounter.selection.hoveredUnit.type == "plant") {
        return {"thickness": 2, "color": "#fcea88"}
    }
}

function UnitGrayscale(stage, unit) {
    // if(unit.grayscale != undefined) {
    //     return {
    //         "value": unit.grayscale
    //     }
    // }
    // if(unit.affiliation == "bad"
    // && unit.state == "idle") { // FOR STEALTH!!
    //     return {"value": 1}
    //     // return {"value": 0}
    // }
    // if(window.tutorial === 0 && unit.key == "blitz"
    // || window.tutorial === 1 && unit.key == "second_baddie") {
    //     return {"value": 1}
    // }
    if(unit.energy["move"] == false
    && unit.energy["invoke skill"] == false) {
        return {"value": 1}
    }
    return {"value": 0}
}

import Pointer from "poin"

function UnitPixelPosition(stage, unit) {
    if(App.game != undefined
    && App.game.encounter != undefined
    && App.game.encounter.phase == "prepare"
    && App.game.encounter.selection.selectedUnitKey == unit.key
    && App.game.encounter.selection.positionBeforeProjection != undefined) { // FROM APOCALYPSE
        return {
            "x": App.game.encounter.selection.positionBeforeProjection.x,
            "y": App.game.encounter.selection.positionBeforeProjection.y + 10,
            "stack": 10000000000, // ???
        }
    }
    const unitLayersByType = {
        "zone": "unit-zone",
    }
    let layer = unitLayersByType[unit.type] || "unit"
    if(unit.state == "submerged") {
        layer = "submerged-unit"
    }
    const position = pixel(layer, UnitPosition(stage, unit))
    // if(unit.reference == "bomb") {
    // // && unit.effects["fuse"] != undefined
    // // && unit.effects["fuse"].timer <= 1) {
    //     position.x += Random.range(-1, 1)
    //     position.y += Random.range(-1, 1)
    // }
    return position
}

function UnitPosition(stage, unit) {
    // // Rendering the unit position as
    // // the future state of the actions.
    // if(Director.isPerforming != true
    // && App.game.encounter != undefined
    // && App.game.encounter.selection != undefined
    // && App.game.encounter.selection.hoveredAction != undefined
    // && App.game.encounter.selection.hoveredAction.omegastage != undefined
    // && App.game.encounter.selection.hoveredAction.omegastage.units != undefined
    // && App.game.encounter.selection.hoveredAction.omegastage.units[unit.key] != undefined) {
    //     const omegaunit = App.game.encounter.selection.hoveredAction.omegastage.units[unit.key]
    //     return omegaunit.position
    // }
    const position = {
        "x": unit.position.x,
        "y": unit.position.y,
        "z": unit.position.z,
    }
    if(unit.transform != undefined
    && unit.transform.position != undefined) {
        position.x += unit.transform.position.x || 0
        position.y += unit.transform.position.y || 0
        position.z += unit.transform.position.z || 0
    }
    // IF YOU UPDATE THIS, ALSO UPDATE THE SHADOW
    return position
}

function ElementalMark(stage, unit) {
    if(unit.opacity != undefined) return

    // if(unit.key != App.game.encounter.selection.hoveredUnitKey
    // && unit.key != App.game.encounter.selection.selectedUnitKey) {
    //     return
    // }

    const element = Elements[unit.element]
    const isDisadvantaged = isElementallyDisadvantaged(stage, unit)
    // const position = {"x": -8, "y": -7}
    const position = {"x": 4, "y": -16}
    if(element != undefined) {
        return {
            "key": "element",
            "position": {
                "x": position.x + (isDisadvantaged ? Random.range(-1, +1) : 0),
                "y": position.y + (isDisadvantaged ? Random.range(-1, +1) : 0),
                "stack": 5,
            },
            "_": [
                {
                    "type": "rectangle",
                    "key": "outline",
                    "color": Colors.black,
                    "width": 4,
                    "height": 4,
                    "anchor": {"x": 0, "y": 0},
                    "position": {"x": 0, "y": 0},
                },
                {
                    "type": "rectangle",
                    "key": "color",
                    "color": element.color,
                    "width": 2,
                    "height": 2,
                    "anchor": {"x": 0, "y": 0},
                    "position": {"x": 1, "y": 1},
                },
            ]
        }
    }
}
function isElementallyDisadvantaged(stage, unit) {
    if(Director.isPerforming != true
    && (App.game.encounter.selection.selectedUnitKey == unit.key
    || App.game.encounter.selection.hoveredUnitKey == unit.key)) {
        const element = Elements[unit.element]
        if(App.game.encounter.selection.hoveredUnitKey == unit.key
        && App.game.encounter.selection.selectedUnitKey != undefined
        && App.game.encounter.selection.selectedUnit.isDead != true
        && App.game.encounter.selection.hoveredUnit.isDead != true
        && App.game.encounter.selection.selectedUnitKey != App.game.encounter.selection.hoveredUnitKey
        && App.game.encounter.selection.selectedUnit.affiliation != App.game.encounter.selection.hoveredUnit.affiliation
        && element != undefined
        && element.weaknesses.includes(App.game.encounter.selection.selectedUnit.element)) {
            return true
        }
        if(App.game.encounter.selection.selectedUnitKey == unit.key
        && App.game.encounter.selection.hoveredUnitKey != undefined
        && App.game.encounter.selection.selectedUnit.isDead != true
        && App.game.encounter.selection.hoveredUnit.isDead != true
        && App.game.encounter.selection.selectedUnitKey != App.game.encounter.selection.hoveredUnitKey
        && App.game.encounter.selection.selectedUnit.affiliation != App.game.encounter.selection.hoveredUnit.affiliation
        && element != undefined
        && element.weaknesses.includes(App.game.encounter.selection.hoveredUnit.element)) {
            return true
        }
    }
}

import calculateTrapPositions from "@frog/source/models/logic/calculateTrapPositions.js"
function TrapSprites(stage, unit) {
    let sprites = []
    if(unit.effects != undefined) {
        Objdict.forEach(unit.effects, (effect, effectKey) => {
            if(effect.type == "trap") {
                sprites = sprites.concat(TrapSprite({stage, unit, effect, effectKey, "opacity": 0.66}))
            }
        })
    }
    if(App.game.encounter?.selection?.hoveredAction?.omegastage?.units != undefined
    && App.game.encounter.selection.hoveredAction.omegastage.units[unit.key] != undefined
    && App.game.encounter.selection.hoveredAction.omegastage.units[unit.key].effects != undefined) {
        const omegastage = App.game.encounter.selection.hoveredAction.omegastage
        const omegaunit = omegastage.units[unit.key]
        Objdict.forEach(omegaunit.effects, (effect, effectKey) => {
            if(effect.type == "trap") {
                sprites = sprites.concat(TrapSprite({"stage": omegastage, "unit": omegaunit, effect, effectKey, "opacity": 0.33}))
            }
        })
    }
    return sprites
}

function TrapSprite({stage, unit, effect, effectKey, opacity}) {
    const positions = calculateTrapPositions({stage, unit, "trap": effect})
    return positions.map((position, index) => {
        return {
            "key": "unit/" + unit.key + "/traps/" + effectKey + "/" + index,
            "anchor": {"x": "50%", "y": "100%"},
            "image": require("@frog/source/assets/images/leviathan-tactics/ui/range-threat.png").default,
            "position": pixel("dangerzone", {
                "x": position.x,
                "y": position.y,
                "z": position.z,
            }),
            "blendmode": "cool",
            "opacity": opacity,
        }
    })
}
